module.exports = __webpack_public_path__ + "static/media/REW_homepage_full.9cb33cf5.jpg";